// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import LoginPage from "./Components/LoginPage";
import SearchBySubject from "./Components/SearchBySubject";
import Management from "./Components/Management";
import Overview from "./Components/ClassOverview";
import ClassroomDisplay from "./Components/ClassroomDisplay";
import FloorPlan from "./Components/test";
import ActiveSessionRooms from "./Components/ActiveSessionRooms";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Overview />} />
        {/* <Route path="/" element={<ClassroomDisplay />} /> */}
        <Route path="/search" element={<SearchBySubject />} />
        <Route path="/management" element={<Management/>} />
        {/* <Route path="/overview" element={<Overview/>} /> */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/floorplan" element={<FloorPlan />} />
        <Route path="/activeroom" element={<ActiveSessionRooms />} />
      </Routes>
    </>
  );
}

export default App;
